module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [(_vm.brand) ? _c('ModalBrand', {
    key: "brand"
  }) : _vm._e(), _vm._v(" "), (_vm.zone) ? _c('ModalZone', {
    key: "zone"
  }) : _vm._e(), _vm._v(" "), (_vm.campaign) ? _c('ModalCampaign', {
    key: "campaign"
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70065d91","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/modal.vue
// module id = 3259
// module chunks = 0